import type { ReactElement, ReactNode } from "react";
import { createContext, createElement, useContext } from "react";
import type { Deal } from "~/models/Deal";

const DealContext = createContext<Deal | null>(null);

type ProviderProps = {
	children: ReactNode;
	deal: Deal;
};

export function DealContextProvider({
	deal,
	children
}: ProviderProps): ReactElement {
	return createElement(DealContext.Provider, { value: deal }, children);
}

export const useDealContext = (): Deal => useContext(DealContext)!;
